import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "200",
  height: "200",
  fill: "none",
  viewBox: "0 0 200 200"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M30 36h134v124H30z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF4500",
      d: "M111.168 116.901h-28v-7h28zM111.168 86.208h-28v-7h28z"
    }, null, -1),
    _createElementVNode("path", {
      fill: "#FF4500",
      "fill-rule": "evenodd",
      d: "M200 200H0V0h200zM55.445 147.815h73.233l16.581-16.581v-19.343l-13.818-13.819 11.054-11.053V69.056l-16.581-16.58H55.445z",
      "clip-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }